import React, { useEffect } from "react";
import { useUtil } from "../../contexts/UtilContext";

const GoogleAnalyticsLoader = () => {
  const { cookiePolicy } = useUtil();

  useEffect(() => {
    if (cookiePolicy === "all") {
      loadGoogleAnalytics();
    }
  }, [cookiePolicy]);

  // Function to load Google Analytics
  const loadGoogleAnalytics = () => {
    console.log("Loading Google Analytics...");
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=G-PNCR70JNTR`;
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      console.log("Google Analytics script loaded successfully");
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-PNCR70JNTR");
    };

    script.onerror = (err) => {
      console.error("Error loading Google Analytics script", err);
    };
  };

  return null; // This component doesn't render anything visible
};

export default GoogleAnalyticsLoader;
